var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.publicFooter)?_c('div',{staticClass:"public-footer-wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"public-footer footer"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.publicFooter)}})])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }